export enum AppStep {
  SCREENSAVER = "SCREENSAVER",
  CUSTOM_URL = "CUSTOM_URL",
  FEEDBACK = "FEEDBACK",
  HOME = "HOME",
}
